import React, {useState} from 'react'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import useModal from '@/hooks/modal'
import {Stack} from '@mui/material'

import {ReactComponent as CloseWhiteIcon} from '@/assets/svgs/CloseWhiteIcon.svg'

interface ModalTranslationProps {
  children: any
  onClose?: () => void
  closable?: boolean
  styles?: {[key: string]: string}
  stylesContainer?: {[key: string]: string}
}

const ModalTranslation = ({
  children,
  onClose,
  closable = true,
  styles,
  stylesContainer,
}: ModalTranslationProps) => {
  const {hideModal} = useModal()
  const [open, setOpen] = useState(true)

  let style = {
    minWidth: 360,
    maxWidth: 700,
    bgcolor: 'background.paper',
    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)',
    borderRadius: 5,
    overflow: 'auto',
    wordBreak: 'break-all',
  }

  let styleContainer = {}

  if (styles) {
    style = {...style, ...styles}
  }

  if (stylesContainer) {
    styleContainer = {...styleContainer, ...stylesContainer}
  }

  const handleClose = () => {
    setOpen(false)
    setTimeout(() => {
      hideModal()
      onClose?.()
    }, 200)
  }

  const handleCloseStack = (ev: any) => {
    if (ev.target.id === 'base-stack') {
      handleClose()
    }
  }
  return (
    <Modal
      id="modal-window"
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}>
      <Fade in={open}>
        <Stack
          id="base-stack"
          width="100%"
          height="100%"
          alignItems="center"
          justifyContent="center"
          position="relative"
          onClick={handleCloseStack}>
          <Stack
            direction="row"
            gap="7px"
            position="relative"
            style={styleContainer}>
            <Box sx={style}>{children}</Box>
            {closable && (
              <Box
                position="absolute"
                top="13px"
                right="20px"
                sx={{cursor: 'pointer'}}
                onClick={handleClose}>
                <CloseWhiteIcon
                  style={{stroke: 'white', width: '50px', height: '50px'}}
                  className="close-white-icon pointer"
                />
              </Box>
            )}
          </Stack>
        </Stack>
      </Fade>
    </Modal>
  )
}

export default ModalTranslation
